import _ from "lodash";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import {
  _COLORS,
  _NUE_PROPRIETE,
  _VENTE_A_TERME_LIBRE,
  _VENTE_A_TERME_OCCUPE,
  _VIAGER_MIXTE,
  _VIAGER_LIBRE,
  _VIAGER_OCCUPE,
  _GESTION_VIAGERE,
  _BAIL_A_NOURRITURE,
} from "../../../utils/_constants";
import { _STYLES } from "../../../utils/_style_constants";
import { editInstantRequest } from "../../../utils/formHelper";
import { NumericFormat } from "react-number-format";
import MouseOverPopover from "../MouseOverPopover";
import HelpIcon from "@mui/icons-material/Help";
import { useState } from "react";
import { arrayMensualite } from "./VentilationPrix";

// Liste des types de ventes pouvant avoir un indice
let arrayIndice = [];
arrayIndice.push(_VIAGER_OCCUPE);
arrayIndice.push(_BAIL_A_NOURRITURE);
arrayIndice.push(_VIAGER_LIBRE);
arrayIndice.push(_VIAGER_MIXTE);
arrayIndice.push(_NUE_PROPRIETE);
arrayIndice.push(_VENTE_A_TERME_OCCUPE);
arrayIndice.push(_GESTION_VIAGERE);
arrayIndice.push(_VENTE_A_TERME_LIBRE);

function VentilationPrixLettreIntentionAchat({
  register,
  errors,
  indices,
  currentMandat,
  setCurrentMandat,
  refresh,
  requestHelper,
  disabledSign = false,
}) {
  const [ventilationPrix, setVentilationPrix] = useState("Bouquet et rente");
  const [ventilationLettreIntention, setVentilationLettreIntention] = useState("");
  const mandatVenteNuePropriete =
    currentMandat?.typeVente?.nom === _NUE_PROPRIETE;
  const mandatVenteTermeLibre =
    currentMandat?.typeVente?.nom === _VENTE_A_TERME_LIBRE;
  const mandatVenteTermeOccupee =
    currentMandat?.typeVente?.nom === _VENTE_A_TERME_OCCUPE;

  const showRente = !!(
    currentMandat?.typeVente?.nom &&
    !arrayMensualite.includes(currentMandat.typeVente.nom)
  );

  useEffect(() => {
    const ventilation =
      currentMandat?.typeVente?.nom === _VIAGER_OCCUPE ||
      currentMandat?.typeVente?.nom === _VIAGER_LIBRE ||
      currentMandat?.typeVente?.nom === _VIAGER_MIXTE
        ? "Bouquet et rente"
        : "Comptant et mensualité";
    setVentilationPrix(ventilation);
  }, [currentMandat]);

  return (
    <>
      <Box sx={{ padding: 4, flexGrow: 1 }}>
        <Grid container columnSpacing={1} rowSpacing={1} padding={2}>
          <Grid item xs={12} display={"flex"} gap={2} alignItems={"baseline"}>
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                color: _COLORS.primary,
              }}
            >
              Conditions de la proposition
            </Typography>
            <MouseOverPopover
              sx={{
                marginLeft: "10px",
              }}
              title={<HelpIcon />}
              popoverText=" Préciser : - Bouquet / comptant (€) : NV ou HAI
                   - Rente / mensualité (€) : mensuelle, trimestrielle ou annuelle, ainsi que la durée de versement si besoin
                   - Durée d’occupation : à vie ou la durée.
                   - Rente réversible à 100% ou non "
            />
          </Grid>

          {/* LISTE DES VENTILATIONS  */}
          <Box
            display={"flex"}
            justifyContent={"center"}
            width={"100%"}
            marginTop={2}
          >
            <Grid
              item
              md={7}
              xs={12}
              display={"flex"}
              flexDirection={"column"}
              padding={1}
              gap={2}
              justifyContent={"center"}
              sx={{
                border: "2px solid rgb(238, 238, 238)",
                borderRadius: "10px",
                borderColor: "#d4bdc8",
                width: "100%",
              }}
            >
              <Typography>{`${ventilationPrix}`}</Typography>
              <TextField
                sx={_STYLES.basicInput}
                size="small"
                id="ventilationLettreIntention"
                label={`${ventilationPrix}*`}
                helperText={
                  errors.ventilationLettreIntention?.type === "required" && (
                    <Typography sx={_STYLES.errorMessage}>
                      Les conditions de la proposition sont obligatoires
                    </Typography>
                  )
                }
                value={
                  ventilationLettreIntention !== ""
                    ? ventilationLettreIntention
                    : currentMandat.ventilationLettreIntention || ""
                }
                // Besoin de changer la valeur du state pour que le composant se rafraichisse
                onChange={(e) => {
                  setVentilationLettreIntention(e.target.value);
                }}
                // On envoie la valeur au serveur
                onBlur={(e) => {
                  let m = editInstantRequest(
                    e.target.value,
                    currentMandat["@id"],
                    "ventilationLettreIntention",
                  );

                  m.then((m) => {
                    if (m["@context"] === "/api/contexts/Error") {
                      refresh();
                    } else {
                      setCurrentMandat(m);
                    }
                  });
                }}
              ></TextField>
            </Grid>
          </Box>

          {/** INDICE ET AUGMENTATION */}
          {currentMandat?.typeVente?.nom && (
            <>
              {/** AUGMENTATION */}
              {arrayMensualite.includes(currentMandat.typeVente.nom) && (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                  }}
                >
                  <Grid
                    item
                    md={7}
                    xs={12}
                    display={"flex"}
                    flexDirection={"column"}
                    padding={1}
                    gap={2}
                    justifyContent={"center"}
                    sx={{
                      border: "2px solid rgb(238, 238, 238)",
                      borderRadius: "10px",
                      borderColor: "#d4bdc8",
                      width: "100%",
                    }}
                  >
                    <Box display={"flex"}>
                      <Grid
                        item
                        md={8}
                        xs={12}
                        display={"flex"}
                        justifyContent={"center"}
                      >
                        <Typography>
                          {!showRente
                            ? "Augmentation de la mensualité en cas de départ anticipé"
                            : "Augmentation de la rente en cas de départ anticipé"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        md={4}
                        xs={12}
                        display={"flex"}
                        flexDirection={"column"}
                        alignItems={"center"}
                        gap={1}
                      >
                        <NumericFormat
                          thousandSeparator=" "
                          allowNegative={false}
                          customInput={TextField}
                          decimalScale={2}
                          displayType="input"
                          disabled={disabledSign}
                          allowedDecimalSeparators={["."]}
                          size="small"
                          id="renteAugmentation"
                          label={
                            showRente
                              ? "Augmentation Rente Viagère"
                              : "Augmentation Mensualité"
                          }
                          value={
                            currentMandat?.renteAugmentation
                              ? currentMandat?.renteAugmentation
                              : ""
                          }
                          {...register("renteAugmentation", {
                            min: {
                              value: 0,
                              message:
                                "Le pourcentage ne peut pas être négatif",
                            },
                            max: 100,
                            onChange: (e) => {
                              setCurrentMandat({
                                ...currentMandat,
                                renteAugmentation: e.target.value.replace(
                                  / /g,
                                  "",
                                ),
                              });
                            },
                            onBlur: (e) => {
                              let m = editInstantRequest(
                                parseFloat(e.target.value.replace(/ /g, "")),
                                currentMandat["@id"],
                                "renteAugmentation",
                              );

                              m.then((m) => {
                                if (m["@context"] === "/api/contexts/Error") {
                                  refresh();
                                } else {
                                  setCurrentMandat(m);
                                }
                              });
                            },
                            validate: (value) =>
                              !_.isNaN(value) || _.isEmpty(value),

                            setValueAs: (value) => {
                              return _.isEmpty(value) ? "" : parseFloat(value);
                            },
                          })}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">%</InputAdornment>
                            ),
                          }}
                        />
                        {errors.renteAugmentation && (
                          <Typography color={"red"}>
                            {errors.renteAugmentation.message}
                          </Typography>
                        )}
                      </Grid>
                    </Box>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Typography fontWeight={"bold"}>OU</Typography>
                    </Grid>
                    <Box display={"flex"}>
                      <Grid
                        item
                        md={8}
                        xs={12}
                        display={"flex"}
                        justifyContent={"center"}
                      >
                        <Typography>Montant mensuel</Typography>
                      </Grid>
                      <Grid
                        item
                        md={4}
                        xs={12}
                        display={"flex"}
                        alignItems={"center"}
                        gap={1}
                      >
                        <NumericFormat
                          thousandSeparator=" "
                          customInput={TextField}
                          allowNegative={false}
                          decimalScale={2}
                          displayType="input"
                          disabled={disabledSign}
                          allowedDecimalSeparators={["."]}
                          size="small"
                          id="montantAugmentation"
                          label="Montant Mensuel"
                          value={
                            currentMandat?.montantAugmentation
                              ? currentMandat?.montantAugmentation
                              : ""
                          }
                          {...register("montantAugmentation", {
                            onChange: (e) => {
                              setCurrentMandat({
                                ...currentMandat,
                                montantAugmentation: e.target.value.replace(
                                  / /g,
                                  "",
                                ),
                              });
                            },
                            onBlur: (e) => {
                              let m = editInstantRequest(
                                parseFloat(e.target.value.replace(/ /g, "")),
                                currentMandat["@id"],
                                "montantAugmentation",
                              );

                              m.then((m) => {
                                if (m["@context"] === "/api/contexts/Error") {
                                  refresh();
                                } else {
                                  setCurrentMandat(m);
                                }
                              });
                            },
                          })}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">€</InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Box>
                  </Grid>
                </Box>
              )}
              {/** FIN AUGMENTATION */}
              {/** INDICE */}
              {arrayIndice.includes(currentMandat.typeVente.nom) && (
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  width={"100%"}
                  marginTop={2}
                >
                  <Grid item md={2} xs={12} marginTop={2}>
                    <Typography>
                      {mandatVenteTermeOccupee ||
                      mandatVenteNuePropriete ||
                      mandatVenteTermeLibre
                        ? "Indexation annuelle de la mensualité" +
                          (!mandatVenteTermeOccupee ? "*" : "")
                        : "Indexation annuelle de la rente*"}
                    </Typography>
                  </Grid>
                  <Grid item md={7} xs={12} marginTop={2}>
                    <FormControl fullWidth size="small">
                      <Select
                        disabled={disabledSign}
                        value={
                          currentMandat?.indice
                            ? currentMandat?.indice["@id"]
                            : ""
                        }
                        onChange={(e) => {
                          let m = editInstantRequest(
                            e.target.value,
                            currentMandat["@id"],
                            "indice",
                          );

                          m.then((m) => {
                            if (m["@context"] === "/api/contexts/Error") {
                              refresh();
                            } else {
                              setCurrentMandat(m);
                            }
                          });
                        }}
                      >
                        {indices.map((indice, i) => (
                          <MenuItem key={i} value={indice["@id"]}>
                            {indice.nom}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {/** pour la VATO en cas de non indice */}
                  {(mandatVenteTermeOccupee ||
                    mandatVenteNuePropriete ||
                    mandatVenteTermeLibre) && (
                    <Grid item md={2} xs={12} marginTop={2} paddingLeft={2}>
                      <FormControlLabel
                        sx={{
                          fontWeight: "bold",
                          fontSize: "1.0rem",
                        }}
                        control={
                          <Checkbox
                            name={"noIndice"}
                            checked={currentMandat?.noIndice}
                            disabled={disabledSign}
                            onChange={(e) => {
                              let m = editInstantRequest(
                                e.target.checked,
                                currentMandat["@id"],
                                "noIndice",
                              );

                              m.then((m) => {
                                if (m["@context"] === "/api/contexts/Error") {
                                  refresh();
                                } else {
                                  setCurrentMandat(m);
                                }
                              });
                            }}
                          />
                        }
                        label={" Pas d'indexation "}
                      />
                    </Grid>
                  )}
                </Box>
              )}
              {/** FIN INDICE */}
            </>
          )}
          {/** FIN INDICE ET AUGMENTATION */}
        </Grid>
      </Box>
    </>
  );
}

export default VentilationPrixLettreIntentionAchat;
